(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rr-collector-videos"] && !Shopify.designMode) return;
  try {
    function initRRCollectorVideos() {
    document.querySelectorAll('[data-rr-collector-videos]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const cards = [...root.querySelectorAll('[data-rr-clip]')];
      const track = root.querySelector('.rr-collector-track');
      const dialog = root.querySelector('dialog');
      const player = dialog.querySelector('video');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let active = 0;
      const updateNav = () => root.querySelectorAll('[data-rr-scroll]').forEach(button => {
        button.disabled = Number(button.dataset.rrScroll) < 0 ? track.scrollLeft < 2 : track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      });
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        const video = entry.target.querySelector('video');
        if (entry.isIntersecting) {
          if (!video.src) { video.src = entry.target.dataset.rrClip + '#t=0.001'; video.preload = 'metadata'; }
          if (!reduced.matches && !dialog.open && !document.hidden) video.play().catch(() => {});
        } else video.pause();
      }), {threshold:0.05});
      cards.forEach(card => observer.observe(card));
      const stopPreviews = () => cards.forEach(card => card.querySelector('video').pause());
      const show = index => {
        active = (index + cards.length) % cards.length;
        stopPreviews();
        player.src = cards[active].dataset.rrClip;
        if (!dialog.open) dialog.showModal();
        player.play().catch(() => {});
      };
      cards.forEach((card,index) => card.addEventListener('click', () => show(index)));
      root.querySelectorAll('[data-rr-scroll]').forEach(button => button.addEventListener('click', () => track.scrollBy({left:Number(button.dataset.rrScroll) * (track.clientWidth * .8),behavior:reduced.matches?'instant':'smooth'})));
      root.querySelectorAll('[data-rr-step]').forEach(button => button.addEventListener('click', () => show(active + Number(button.dataset.rrStep))));
      dialog.querySelector('.rr-collector-close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) { const rect=dialog.getBoundingClientRect(); if(event.clientX<rect.left || event.clientX>rect.right || event.clientY<rect.top || event.clientY>rect.bottom) dialog.close(); } });
      dialog.addEventListener('close', () => { player.pause(); player.removeAttribute('src'); player.load(); cards.forEach(card => {observer.unobserve(card); observer.observe(card);}); });
      document.addEventListener('visibilitychange', () => { if(document.hidden) {stopPreviews();player.pause();} else cards.forEach(card => {observer.unobserve(card);observer.observe(card);}); });
      track.addEventListener('scroll',updateNav,{passive:true});
      new ResizeObserver(updateNav).observe(track);
      updateNav();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initRRCollectorVideos); else initRRCollectorVideos();
  document.addEventListener('shopify:section:load',initRRCollectorVideos);
  } catch(e) { console.error(e); }
})();

})();
